import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import { Grid, GridColumn as Column, GridCell, GridSortChangeEvent, GridHeaderCell, GridNoRecords } from '@progress/kendo-react-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
import { DatePicker, DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { format } from 'util';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>;

type State = {
    sort: SortDescriptor[];
    Payments: PaymentData[];
    from: Date;
    to: Date;
    isLoading: boolean;
}

export interface PaymentData {
    PaymentID: number;
    AccountID: string;
    BillingName: string;
    BillingEmail: string;
    Comment: string;
    Amount: string;
    Date: Date;
}

class NameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={`/accounts/${this.props.dataItem.AccountID}/payments`}>
                    {this.props.dataItem.BillingName}
                </Link>
            </td>
        );
    }
}

class SourceCell extends GridCell {
    render() {
        return (
            <td>{this.GetSourceName(this.props.dataItem.Source)}</td>
        );
    }

    private GetSourceName(source: number): string {
        switch (source) {
            case 0:
                return 'Cash';
            case 1:
                return 'Cheque';
            case 2:
                return 'e-Transfer';
            case 3:
                return 'Credit Card';
            case 4:
                return 'Reversed';
            case 5:
                return 'Discount';
            default:
                return 'Unknown';
        }
    }
}

class DateCell extends GridCell {
    render() {
        if (!this.props.field) return null;

        return (
            <td>{moment.utc(this.props.dataItem[this.props.field]).local().format("YYYY-MM-DD")}</td>
        );
    }
}

export default class Payments extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            Payments: [],
            isLoading: false,
            from: moment().subtract('month', 1).toDate(),
            to: moment().add('day', 1).toDate(),
            sort: [{ field: 'Date', dir: 'desc' }],
        };
        this.setFromDate = this.setFromDate.bind(this);
        this.setToDate = this.setToDate.bind(this);
        this.sortChange = this.sortChange.bind(this);
    }

    public componentWillMount() {
        this.getPayments();
    }

    public render() {
        return <React.Fragment>
            {this.state.isLoading && <LoadingPanel />}
            <DocumentTitle title="Payments" />
            <div className="row">
                <div className="col">
                    <h1>Payments</h1>
                </div>
                <div className="col" style={{ display: 'flex' }}>
                    <div style={{ paddingRight: 5 }}>
                        <DatePicker value={this.state.from} onChange={this.setFromDate} />
                    </div>
                    <div>
                        <DatePicker value={this.state.to} onChange={this.setToDate} />
                    </div>
                </div>
            </div>
            <Grid data={this.state.Payments}
                sortable={{
                    allowUnsort: true
                }}
                sort={this.state.sort}
                onSortChange={this.sortChange}
            >
                <GridNoRecords>
                    No Payments Found.
                </GridNoRecords>
                <Column field="Name" title="Name" cell={NameCell} />
                <Column field="Source" title="Payment Type" cell={SourceCell}  />
                <Column field="Amount" format="{0:c}" filter="numeric" />
                <Column field="Comment" />
                <Column field="Date" cell={DateCell} filter="date" />
            </Grid>
            <br />
        </React.Fragment>;
    }

    private setFromDate(e: DatePickerChangeEvent) {
        if (this.state.to < e.value) {
            alert('From date must be before to date');
            return;
        }
        this.setState({ from: e.value }, this.getPayments);
    }

    private setToDate(e: DatePickerChangeEvent) {
        if (this.state.from > e.value) {
            alert('To date must be after from date');
            return;
        }
        this.setState({ to: e.value }, this.getPayments);
    }

    private sortChange(event: GridSortChangeEvent) {
        this.setState({
            sort: event.sort,
            Payments: orderBy(this.state.Payments, event.sort)
        });
    }

    private getPayments() {
        this.setState({ isLoading: true });
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID"),
            From: this.state.from,
            To: this.state.to
        }
        fetchApi('api/Reports/Payments', data, 'POST')
            .then((data: PaymentData[]) => {
                this.setState({ Payments: data, isLoading: false });
            });
    }
}
